import { Component, OnInit, ViewChild } from "@angular/core";
import { Post } from "src/models/post.model";
import { ITag } from "src/models/wpModels";
import { PostStore } from "src/stores/post.store";
import { TagsStore } from "src/stores/tags.store";

@Component({
  selector: "app-search",
  templateUrl: "./search.page.html",
  styleUrls: ["./search.page.scss"],
})
export class SearchPage implements OnInit {
  @ViewChild("tagSelect", { static: false }) tagSelect;
  allPosts: Post[] = [];
  selectedPhase: number;
  searchResults: Post[];
  selectedTag: number;
  phases: IPhase[] = [
    { name: "Upper Primary (IP)", category: 6 },
    { name: "Lower Secondary (SP)", category: 5 },
    { name: "Upper Secondary (FET)", category: 4 },
  ];
  constructor(public tagsStore: TagsStore, public postStore: PostStore) {}
  ngOnInit() {}

  // sort tags by post count and return top 30

  togglePhase(phase: IPhase) {
    this.selectedPhase = phase.category;
    this.search();
  }

  toggleTag(tag: ITag) {
    if (this.selectedTag && this.selectedTag == tag.id) {
      this.selectedTag = null;
    } else {
      this.selectedTag = tag.id;
    }
    this.search();
  }

  showMoreTags() {
    this.tagSelect.open();
  }

  search() {
    // sort by selected phases
    this.postStore.filterActivities(this.selectedPhase, this.selectedTag);
  }

  filterByTag(posts: Post[] = []) {
    if (this.selectedTag) {
      posts = posts.filter((p) => p.values.tags && p.values.tags.includes(this.selectedTag));
    }
    return posts;
  }

  // iterate over each of the selected filter categories and pass if it matches at least one
  // filterByCategory(posts: Post[] = []) {
  //   const filteredCategories: number[] = [];
  //   Object.keys(this.selectedPhases).forEach(key => {
  //     if (this.selectedPhases[key].selected == true) {
  //       filteredCategories.push(this.selectedPhases[key].category);
  //     }
  //   });
  //   if (filteredCategories.length > 0) {
  //     posts = posts.filter(p => {
  //       let categoryPass = false;
  //       filteredCategories.forEach(c => {
  //         if (p.values.categories && p.values.categories.includes(c)) {
  //           categoryPass = true;
  //         } else {
  //         }
  //       });
  //       return categoryPass;
  //     });
  //   }
  //   return posts;
  // }
}

interface IPhase {
  name: string;
  category: number;
}
